























import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class AlignLeftOff extends Vue {
    @Prop() private userConfigColor! : string;
}
